<script lang="ts">
  import Avatar from '$components/Avatar.svelte';

  import MetafyPartnerBadge from '$components/icons/MetafyProBadge/MetafyPartnerBadge.svelte';
  import { MetafyPartnerEnum } from '$lib/types/api/graphql';

  export let coach = {};
  let className = 'sm:hover:bg-ondark-low';
  export { className as class };
</script>

<a
  href="/@{coach.slug}"
  class="focus-visible:bg-ondark-low focus-visible:ring-ondark-focused group flex h-14 items-center justify-between space-x-3 rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 sm:px-3 {className}"
  on:keydown
  on:click
>
  <div class="flex min-w-0 flex-1 items-center space-x-4">
    <Avatar user={coach} class="bg-ondark-medium size-6" sizes={{ xs: 24 }} rounded="rounded" />
    <span class="highlight text-ondark-primary truncate">{@html coach._formatted?.name}</span>
    {#if coach.is_pro || coach.is_core}
      <MetafyPartnerBadge variant={coach.is_core ? MetafyPartnerEnum.Core : MetafyPartnerEnum.Pro} size="xs" />
    {/if}
  </div>
</a>
